import { AssignChannelsV2Query, AssignChannelsV2QueryVariables, SortEnum } from '@/types/generated/graphql';
import { useState } from 'react';
import { useCursorPagination } from '@shared/hooks/use-cursor-pagination';
import { CURSOR_ASSIGN_CHANNELS_V2 } from '@/graphql/cursor.graphql';

function useAssignChannels() {
  const [filter, setFilter] = useState({
    query: '',
    order: 'isDefault',
    sort: SortEnum.DESC,
  });

  const { data, loading, initialLoading, hasNextPage, loadNextRef } = useCursorPagination<
    AssignChannelsV2Query,
    AssignChannelsV2QueryVariables
  >({
    schema: CURSOR_ASSIGN_CHANNELS_V2,
    responseDataKey: 'assignChannelsV2',
    variables: filter,
  });

  return {
    data,
    loading,
    loadNextRef,
    filter,
    setFilter,
    hasNextPage,
    initialLoading,
  };
}

export default useAssignChannels;
